"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScaleMode = void 0;

var _bbox = _interopRequireDefault(require("@turf/bbox"));

var _centroid = _interopRequireDefault(require("@turf/centroid"));

var _bearing = _interopRequireDefault(require("@turf/bearing"));

var _bboxPolygon = _interopRequireDefault(require("@turf/bbox-polygon"));

var _helpers = require("@turf/helpers");

var _polygonToLine = _interopRequireDefault(require("@turf/polygon-to-line"));

var _meta = require("@turf/meta");

var _distance = _interopRequireDefault(require("@turf/distance"));

var _transformScale = _interopRequireDefault(require("@turf/transform-scale"));

var _invariant = require("@turf/invariant");

var _utils = require("../utils");

var _geojsonEditMode = require("./geojson-edit-mode");

var _immutableFeatureCollection = require("./immutable-feature-collection");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ScaleMode = /*#__PURE__*/function (_GeoJsonEditMode) {
  _inherits(ScaleMode, _GeoJsonEditMode);

  var _super = _createSuper(ScaleMode);

  function ScaleMode() {
    var _this;

    _classCallCheck(this, ScaleMode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_geometryBeingScaled", void 0);

    _defineProperty(_assertThisInitialized(_this), "_selectedEditHandle", void 0);

    _defineProperty(_assertThisInitialized(_this), "_cornerGuidePoints", void 0);

    _defineProperty(_assertThisInitialized(_this), "_cursor", void 0);

    _defineProperty(_assertThisInitialized(_this), "_isScaling", false);

    _defineProperty(_assertThisInitialized(_this), "_isSinglePointGeometrySelected", function (geometry) {
      var _ref = geometry || {},
          features = _ref.features;

      if (Array.isArray(features) && features.length === 1) {
        // @ts-ignore
        var _getGeom = (0, _invariant.getGeom)(features[0]),
            type = _getGeom.type;

        return type === 'Point';
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "_getOppositeScaleHandle", function (selectedHandle) {
      var selectedHandleIndex = selectedHandle && selectedHandle.properties && Array.isArray(selectedHandle.properties.positionIndexes) && selectedHandle.properties.positionIndexes[0];

      if (typeof selectedHandleIndex !== 'number') {
        return null;
      }

      var guidePointCount = _this._cornerGuidePoints.length;
      var oppositeIndex = (selectedHandleIndex + guidePointCount / 2) % guidePointCount;
      return _this._cornerGuidePoints.find(function (p) {
        if (!Array.isArray(p.properties.positionIndexes)) {
          return false;
        }

        return p.properties.positionIndexes[0] === oppositeIndex;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_getUpdatedData", function (props, editedData) {
      var updatedData = new _immutableFeatureCollection.ImmutableFeatureCollection(props.data);
      var selectedIndexes = props.selectedIndexes;

      for (var i = 0; i < selectedIndexes.length; i++) {
        var selectedIndex = selectedIndexes[i];
        var movedFeature = editedData.features[i];
        updatedData = updatedData.replaceGeometry(selectedIndex, movedFeature.geometry);
      }

      return updatedData.getObject();
    });

    _defineProperty(_assertThisInitialized(_this), "isEditHandleSelected", function () {
      return Boolean(_this._selectedEditHandle);
    });

    _defineProperty(_assertThisInitialized(_this), "getScaleAction", function (startDragPoint, currentPoint, editType, props) {
      if (!_this._selectedEditHandle) {
        return null;
      }

      var oppositeHandle = _this._getOppositeScaleHandle(_this._selectedEditHandle);

      var origin = (0, _invariant.getCoord)(oppositeHandle); // @ts-ignore

      var scaleFactor = getScaleFactor(origin, startDragPoint, currentPoint); // @ts-ignore

      var scaledFeatures = (0, _transformScale["default"])( // @ts-ignore
      _this._geometryBeingScaled, scaleFactor, {
        origin: origin
      });
      return {
        updatedData: _this._getUpdatedData(props, scaledFeatures),
        editType: editType,
        editContext: {
          featureIndexes: props.selectedIndexes
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "updateCursor", function (props) {
      if (_this._selectedEditHandle) {
        if (_this._cursor) {
          props.onUpdateCursor(_this._cursor);
        }

        var cursorGeometry = _this.getSelectedFeaturesAsFeatureCollection(props); // Get resize cursor direction from the hovered scale editHandle (e.g. nesw or nwse)


        var centroid = (0, _centroid["default"])(cursorGeometry);
        var bearing = (0, _bearing["default"])(centroid, _this._selectedEditHandle);
        var positiveBearing = bearing < 0 ? bearing + 180 : bearing;

        if (positiveBearing >= 0 && positiveBearing <= 90 || positiveBearing >= 180 && positiveBearing <= 270) {
          _this._cursor = 'nesw-resize';
          props.onUpdateCursor('nesw-resize');
        } else {
          _this._cursor = 'nwse-resize';
          props.onUpdateCursor('nwse-resize');
        }
      } else {
        props.onUpdateCursor(null);
        _this._cursor = null;
      }
    });

    return _this;
  }

  _createClass(ScaleMode, [{
    key: "handlePointerMove",
    value: function handlePointerMove(event, props) {
      if (!this._isScaling) {
        var selectedEditHandle = (0, _utils.getPickedEditHandle)(event.picks);
        this._selectedEditHandle = selectedEditHandle && selectedEditHandle.properties.editHandleType === 'scale' ? selectedEditHandle : null;

        if (selectedEditHandle) {
          this.updateCursor(props);
        }
      }
    }
  }, {
    key: "handleStartDragging",
    value: function handleStartDragging(event, props) {
      if (this._selectedEditHandle) {
        this._isScaling = true;
        this._geometryBeingScaled = this.getSelectedFeaturesAsFeatureCollection(props);
      }
    }
  }, {
    key: "handleDragging",
    value: function handleDragging(event, props) {
      if (!this._isScaling) {
        return;
      }

      props.onUpdateCursor(this._cursor);
      var scaleAction = this.getScaleAction(event.pointerDownMapCoords, event.mapCoords, 'scaling', props);

      if (scaleAction) {
        props.onEdit(scaleAction);
      }

      event.cancelPan();
    }
  }, {
    key: "handleStopDragging",
    value: function handleStopDragging(event, props) {
      if (this._isScaling) {
        // Scale the geometry
        var scaleAction = this.getScaleAction(event.pointerDownMapCoords, event.mapCoords, 'scaled', props);

        if (scaleAction) {
          props.onEdit(scaleAction);
        }

        props.onUpdateCursor(null);
        this._geometryBeingScaled = null;
        this._selectedEditHandle = null;
        this._cursor = null;
        this._isScaling = false;
      }
    }
  }, {
    key: "getGuides",
    value: function getGuides(props) {
      this._cornerGuidePoints = [];
      var selectedGeometry = this.getSelectedFeaturesAsFeatureCollection(props); // Add buffer to the enveloping box if a single Point feature is selected

      if (this._isSinglePointGeometrySelected(selectedGeometry)) {
        return {
          type: 'FeatureCollection',
          features: []
        };
      }

      var boundingBox = (0, _bboxPolygon["default"])((0, _bbox["default"])(selectedGeometry));
      boundingBox.properties.mode = 'scale';
      var cornerGuidePoints = [];
      (0, _meta.coordEach)(boundingBox, function (coord, coordIndex) {
        if (coordIndex < 4) {
          // Get corner midpoint guides from the enveloping box
          var cornerPoint = (0, _helpers.point)(coord, {
            guideType: 'editHandle',
            editHandleType: 'scale',
            positionIndexes: [coordIndex]
          });
          cornerGuidePoints.push(cornerPoint);
        }
      });
      this._cornerGuidePoints = cornerGuidePoints; // @ts-ignore

      return (0, _helpers.featureCollection)([(0, _polygonToLine["default"])(boundingBox)].concat(_toConsumableArray(this._cornerGuidePoints)));
    }
  }]);

  return ScaleMode;
}(_geojsonEditMode.GeoJsonEditMode);

exports.ScaleMode = ScaleMode;

function getScaleFactor(centroid, startDragPoint, currentPoint) {
  var startDistance = (0, _distance["default"])(centroid, startDragPoint);
  var endDistance = (0, _distance["default"])(centroid, currentPoint);
  return endDistance / startDistance;
}